import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '3rem',
    width: '100%',
    fontSize: theme.size.sm,

    '& > div': {
      flex: '1 1 auto',
      display: 'flex',
      alignItems: 'center',
      height: '100%'
    },

    '& .num': {
      marginLeft: '1rem'
    },

    '& .buttons': {
      justifyContent: 'center',
      overflow: 'hidden'
    }
  },

  smallRoot: {
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: '1rem 0 0 0',
    height: 'unset',
    borderBottom: '0.0625rem solid rgba(230, 234, 236, 0.9)',

    '& > div:last-child': {
      display: 'none'
    },

    '& > div': {
      marginBottom: '1rem'
    },

    '& .buttons': {
      width: 'calc(100% - 2rem)',
      padding: '0 1rem'
    }
  }
}))

export default useStyles
